import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 0',
    userSelect: 'none',
  },
  dot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    flexShrink: 0,
  },
  title: {
    fontWeight: 700,
    fontSize: '0.85rem',
    color: '#172b4d',
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  badge: {
    background: '#e2e8f0',
    color: '#64748b',
    fontSize: '0.72rem',
    fontWeight: 700,
    borderRadius: 10,
    padding: '1px 7px',
    flexShrink: 0,
  },
  value: {
    fontSize: '0.72rem',
    color: '#16a34a',
    fontWeight: 700,
    flexShrink: 0,
    background: '#dcfce7',
    borderRadius: 10,
    padding: '1px 7px',
  },
}));

const KanbanLaneHeader = ({ title, color, cards }) => {
  const classes = useStyles();

  const totalValue = (cards || []).reduce((sum, card) => {
    return sum + (card.opportunityValue || 0);
  }, 0);

  return (
    <div className={classes.header}>
      <span
        className={classes.dot}
        style={{ background: color || '#757575' }}
      />
      <Typography className={classes.title}>{title}</Typography>
      <span className={classes.badge}>{(cards || []).length}</span>
      {totalValue > 0 && (
        <span className={classes.value}>
          R$ {totalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>
      )}
    </div>
  );
};

export default KanbanLaneHeader;
